<template>
  <sweet-modal :title="$t('settings_COA') + ' - ' + (state === 'create' ? $t('settings_addSubAccount') : $t('settings_editSubAccount'))" blocking ref="modal" class="modal" v-on:close="close">
    <el-form :model="form" ref="form" status-icon :rules="rules" label-position="left">
      <el-form-item prop="dbCode">
        <el-input v-if="state !== 'create'" readonly :label="$t('settings_accountThink_GLAccounts_dbCode')" v-model="form.dbCode"></el-input>
      </el-form-item>
      <el-form-item prop="accNo">
        <el-input :label="$t('settings_accountThink_GLAccounts_accNo')" v-model="form.number"></el-input>
      </el-form-item>
      <el-form-item prop="type">
        <el-input readonly :label="$t('settings_accountThink_GLAccounts_(type)')" v-model="type.name"></el-input>
      </el-form-item>
      <el-form-item prop="class">
        <el-input readonly :label="$t('settings_accountThink_GLAccounts_(class)')" v-model="myClass.name"></el-input>
      </el-form-item>
      <el-form-item prop="group">
        <el-input readonly :label="$t('settings_accountThink_GLAccounts_(group)')" v-model="group.name"></el-input>
      </el-form-item>
      <el-form-item prop="account">
        <el-input readonly :label="$t('settings_accountThink_GLAccounts_(account)')" v-model="account.name"></el-input>
      </el-form-item>
      <el-form-item v-for="(subAccount, index) in subAccounts" :key="subAccount.id" prop="subAccount">
        <el-input readonly :label="$t('settings_accountThink_GLAccounts_(subIndexAccount)', {index: index + 1})" v-model="subAccount.name"></el-input>
      </el-form-item>
      <el-form-item prop="name">
        <el-autocomplete
            :label="$t('settings_accountThink_GLAccounts_(subAccount)')"
            :fetch-suggestions="querySearch"
            value-key="name"
            v-model="form.name">
        </el-autocomplete>
      </el-form-item>
      <el-form-item label-width="120px" prop="setAs" style="margin-bottom: 0;" :label="$t('settings_accountThink_GLAccounts_setAs')">
        <el-radio-group v-model="form.DRCRCode" size="small" disabled>
          <el-radio label="DR" border style="margin-right: 0;">DR</el-radio>
          <el-radio label="CR"  border>CR</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label-width="120px" prop="accountType" style="margin-bottom: 0;" label="Account Type">
<!--        <el-radio-group v-show="false" :disabled="state === 'update'" v-model="form.accountType">-->
<!--          <el-radio :label="1">Default Account</el-radio>-->
<!--          <el-radio :label="2">Tax Account</el-radio>-->
<!--          <el-radio v-if="isBankAccountAvailable" :label="3">Bank Account</el-radio>-->
<!--          <el-radio v-if="isCreditCardAccountAvailable" :label="4">Credit Card Account</el-radio>-->
<!--        </el-radio-group>-->
        <el-radio readonly>{{accountTypeName}}</el-radio>
      </el-form-item>
      <el-card v-if="form.accountType === 2">
        <el-form-item label-width="120px" size="mini" prop="taxTypeId" :label="$t('modal_taxLibraries')">
          <el-select v-model="form.taxTypeId" :placeholder="$t('modal_taxLibraries')" style="width: 300px;" @change="handleSelectTaxType">
            <el-option
                v-for="type in taxTypes"
                :key="type.id"
                :label="type.name"
                :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="120px" size="mini" prop="taxId" :label="$t('modal_taxCode')">
          <el-select :disabled="!form.taxTypeId" v-model="form.taxId" :placeholder="$t('modal_taxCode')" style="width: 300px;">
            <el-option
                v-for="type in taxes"
                :key="type.id"
                :label="type.name"
                :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-card>
      <el-form-item label-width="120px" prop="accountCurrencyId" label="Currency">
        <el-select v-model="form.accountCurrencyId" no-data-text="no date" placeholder="Currency" filterable>
          <el-option
              v-for="item in currencyList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="120px" prop="accountId" label="Account Tax">
        <el-select v-model="form.accountId" no-data-text="no date" placeholder="Not Assigned" filterable>
          <el-option
              v-for="item in accounts"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="120px" prop="cashFlow" style="margin-bottom: 0;" label="Cash Flow">
        <el-select v-model="form.clashflowId" no-data-text="no date" placeholder="Cash Flow" filterable clearable>
          <el-option
              v-for="item in cashFlowList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="modal__btn" style="float:right;">
        <el-button v-if="state === 'create'" @click="create('form')" type="primary">{{$t('general_add')}}</el-button>
        <el-button v-else @click="update('form')" type="primary">{{$t('general_update')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "COAAddSubAccountModal",
  props: {
    rowData: {
      type: Array,
      default: () => ([])
    },
    currencyList: {
      type: Array,
      default: () => ([])
    },
    cashFlowList: {
      type: Array,
      default: () => ([])
    },
    accountsNamesList: {
      type: Array,
      default: () => ([])
    },
    accounts: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
    isBankAccountAvailable() {
      return this.group.code.length && this.group.code[0] === '1'
    },
    isCreditCardAccountAvailable() {
      return this.group.code.length && this.group.code[0] === '2'
    }
  },
  data() {
    return {
      state: 'create',
      form: {
        dbCode: null,
        number: null,
        name: null,
        DRCRCode: 'CR',
        // makeInactive: false,
        clashflowId: null,
        isBankAccount: false,
        accountType: 1,
        taxTypeId: null,
        taxId: null,
        groupId: null,
        parentId: null,
        filePath: [],
        accountCurrencyId: null,
        accountId: null
      },
      rules: {
        name: [
          { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        taxTypeId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        taxId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        accountId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        clashflowId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ]
      },
      params: {
        data: {
          taxId: null
        }
      },
      account: {},
      subAccounts: [],
      type: {},
      myClass: {},
      group: {
        code: ''
      },
      taxTypes: [
        { id: 1, name: this.$t('settings_accountThink_taxTypes_taxes') },
        { id: 2, name: this.$t('settings_accountThink_taxTypes_withholdingTaxes') }
      ],
      taxes: [],
      // cashFlowList: ['Operating', 'Investing', 'Financing']
      accountTypeName: null
    }
  },
  components: {
    SweetModal
  },
  methods: {
    openModal(state, params) {
      console.log('params', params, this.rowData)
      if (this.companyLayout.currency) this.form.accountCurrencyId = this.companyLayout.currency.id
      this.params = params
      this.type = this.rowData.find(bal => bal.id === params.node.data.filePath[0] && bal.entityType === 'type')
      this.myClass = this.rowData.find(bal => bal.id === params.node.data.filePath[1] && bal.entityType === 'class')
      this.group = this.rowData.find(bal => bal.id === params.node.data.filePath[2] && bal.entityType === 'group')
      this.account = this.rowData.find(bal => bal.id === params.node.data.filePath[params.node.data.filePath.length - 1] && bal.entityType === 'account')

      // if (params.node.data.filePath.length > 4) {
      //   const subAccounts = params.node.data.filePath.slice(4)
      //   subAccounts.forEach(val => {
      //     const account = this.rowData.find(bal => bal.id === val && bal.entityType === 'sub-account')
      //     this.subAccounts.push(account)
      //   })
      // }

      this.form.groupId = params.node.data.groupId
      this.form.parentId = params.node.data.id
      this.form.DRCRCode = params.node.data.DRCRCode
      this.form.filePath = params.node.data.filePath
      this.form.clashflowId = this.group.clashflowId ? this.group.clashflowId : null
      this.accountTypeName = params.node.data.accountTypeName

      if (params.node.data.isBankAccount) {
        this.form.accountType = 3
      } else if (params.node.data.isCreditCardAccount) {
        this.form.accountType = 4
      }

      this.state = state
      this.$refs.modal.open()
      console.log('open modal', state)
    },
    openModalEdit(state, params) {
      this.params = params

      params.node.data.filePath.forEach((val, index) => {
        if (index === 0) this.type = this.rowData.find(bal => bal.id === val && bal.entityType === 'type')
        if (index === 1) this.myClass = this.rowData.find(bal => bal.id === val && bal.entityType === 'class')
        if (index === 2) this.group = this.rowData.find(bal => bal.id === val && bal.entityType === 'group')
        if (index === 3) this.account = this.rowData.find(bal => bal.id === val&& bal.entityType === 'account')
      })

      this.form.accountCurrencyId = params.node.data.accountCurrencyId ? params.node.data.accountCurrencyId : params.node.data.currencyId
      this.form.groupId = params.node.data.groupId
      this.form.name = params.node.data.name
      this.form.number = params.node.data.number
      this.form.parentId = params.node.data.id
      this.form.DRCRCode = params.node.data.DRCRCode
      this.form.filePath = params.node.data.filePath
      this.form.dbCode = params.node.data.code
      // this.form.makeInactive = !params.node.data.active
      this.form.clashflowId = params.node.data.clashflowId
      if (params.node.data.taxId) {
        this.form.taxId = params.node.data.taxId
        this.form.taxTypeId = params.node.data.taxTypeId
        this.handleSelectTaxType(this.form.taxTypeId, true)
        this.form.accountType = 2
      } else if (params.node.data.isBankAccount) {
        this.form.accountType = 3
      } else if (params.node.data.isCreditCardAccount) {
        this.form.accountType = 4
      }
      // const subAccountsIds = params.node.data.filePath.slice(4)
      // this.subAccounts = this.rowData.filter(val => subAccountsIds.includes(val.id) && val.entityType === 'sub-account' && val.id !== params.node.data.id)

      this.state = state
      this.$refs.modal.open()
    },
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          const payload = {
            groupId: this.form.groupId,
            parentId: this.form.parentId,
            filePath: this.form.filePath,
            name: this.form.name,
            number: this.form.number,
            clashflowId: this.form.clashflowId,
            isBankAccount: this.form.accountType === 3,
            isCreditCardAccount: this.form.accountType === 4,
            // active: !this.form.makeInactive,
            accountCurrencyId: this.form.accountCurrencyId,
            type: 'folder'
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/account/subAccount?companyId=${this.$route.query.companyId}`, payload)
              .then(async response => {
                try {
                  if (this.form.accountType === 2) {
                    await this.createTaxAccount(response.data.id)
                  }
                  if (this.form.accountId) {
                    await this.assignTax(response.data.id)
                  }
                  console.log('response', response.data);
                  this.notification(this.$t('general_success'), this.$t('setting_accountCreated'), "success");
                  this.$emit('loadList', { entityType: response.data.entityType, id: response.data.id })
                  loader.hide()
                  this.$refs.modal.close()
                } catch (err) {
                  console.log(err)
                }
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              })
        }
      })
    },
    update(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$refs[form].validate((valid) => {
            if (valid) {
              let loader = this.$loading.show();
              const payload = {
                name: this.form.name,
                number: this.form.number,
                clashflowId: this.form.clashflowId,
                isBankAccount: this.form.accountType === 3,
                isCreditCardAccount: this.form.accountType === 4,
                // active: !this.form.makeInactive,
                accountCurrencyId: this.form.accountCurrencyId
              }
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/account/update?accountId=${this.params.node.data.id}`, payload)
                  .then(async response => {
                    try {
                      if (this.form.accountType === 2) {
                        await this.createTaxAccount(this.params.node.data.id)
                      }
                      if (this.form.accountId) {
                        await this.assignTax(this.params.node.data.id)
                      }
                      console.log('response', response.data);
                      this.notification(this.$t('general_success'), this.$t('setting_subAccountUpdated'), "success");
                      this.$emit('loadList', { entityType: 'account', id: this.params.node.data.id })
                      loader.hide()
                      this.$refs.modal.close()
                    } catch (err) {
                      console.log(err)
                    }
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  })
            }
          })
        }
      })
    },
    handleSelectTaxType(type, dontRemoveTax) {
      if (!dontRemoveTax) this.form.taxId = null
      this.taxes = []
      let url = ''
      switch (type) {
        case 1:
          url = `/api/v1/projectTaxes/list?companyId=${this.$route.query.companyId}`
          break;
        case 2:
          url = `/api/v1/withholdingTaxes/list?companyId=${this.$route.query.companyId}`
          break;
      }
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(url).then(response => {
        console.log(response)
        this.taxes = response.data.list
        loader.hide()
      }).catch(err => {
        console.log(err)
        loader.hide()
      })
    },
    async assignTax(accountId) {
      try {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/account/assignAccountToTaxAccount?accountId=${accountId}&assignToTaxAccountId=${this.form.accountId}`)
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    },
    createTaxAccount(accountId) {
      return new Promise ((resolve) => {
        const payload = {
          taxTypeId: this.form.taxTypeId,
          taxId: this.form.taxId
        }
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/account/addTax?accountId=${accountId}`, payload).then(response => {
          console.log(response)
          loader.hide()
          resolve(response)
          // this.notification(this.$t('modal_settings_success'), this.$t('modal_settings_taxSuccessfullyCreated'), "success")
          // this.$refs.modal.close()
          // loader.hide()
          // this.$emit('loadList', { entityType: 'account', id: this.params.data.id })
        }).catch(err => {
          console.log(err)
          loader.hide()
        })
      })
    },
    close() {
      this.state = 'create'
      this.form.dbCode = null
      // this.form.type = null
      this.form.DRCRCode = 'CR'
      // this.form.classId = null
      this.form.accountCurrencyId = null
      this.form.parentId = null
      this.form.filePath = []
      this.form.name = null
      // this.form.makeInactive = false
      this.form.number = null
      this.form.clashflowId = null
      this.form.isBankAccount = false
      this.form.taxTypeId = null
      this.form.taxId = null
      this.form.accountId = null
      this.form.accountType = 1
      this.taxes = []
      this.params = {
        data: {
          taxId: null
        }
      }
      this.type = {}
      this.myClass = {}
      this.group = {
        code: ''
      }
      this.account = {}
      this.subAccounts = []
      this.accountTypeName = null
      this.$refs['form'].resetFields()
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    querySearch(queryString, cb) {
      let links = this.accountsNamesList;
      let results = queryString ? links.filter(this.createFilter(queryString)) : links;
      console.log(results)
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return (link) => {
        return (link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      }
    },
    handleSelect(item) {
      console.log(item);
    }
  }
}
</script>

<style scoped>

</style>
